import {
  useApiMutation,
  createBulkDownload,
  getBulkDownloadTaskStatus,
  useApiPolling,
} from '@hum/api';
import { BulkDownloadStatus } from '@hum/types';

export const useBulkDownload = ({ companyId }: { companyId: string }) => {
  const { mutate: downloadAllFiles } = useApiMutation(createBulkDownload, {
    onSuccess(data) {
      if (data?.taskId) {
        startPolling({ companyId, taskId: data.taskId });
      }
    },
  });

  const {
    data: task,
    isPolling,
    startPolling,
    stopPolling,
    isError,
  } = useApiPolling(getBulkDownloadTaskStatus, {
    onPollSuccess(data) {
      if (!data) return;

      const isTerminalState = [
        BulkDownloadStatus.Failure,
        BulkDownloadStatus.Revoked,
        BulkDownloadStatus.Success,
      ].includes(data.state);

      if (isTerminalState || isError) {
        stopPolling();

        if (data.state === BulkDownloadStatus.Success && data.fileUrl) {
          window.location.assign(data.fileUrl);
        }
      }
    },
  });

  return {
    task,
    isPolling,
    isError,
    stopDownload: stopPolling,
    handleDownloadAllFilesClick: () => downloadAllFiles({ companyId }),
  };
};
